import { useTranslation } from "react-i18next";
import { Text } from "components/text";
import { ManuscriptProcessingCopyButton } from "./ManuscriptProcessingCopyButton";
import { ManuscriptProcessingRow } from "./ManuscriptProcessingRow";

// A button rather than a Link: entries have no route of their own, so opening
// the original swaps the sheet's contents in place.
export const ManuscriptProcessingOriginalEntry = ({
  reportId,
  onOpen,
}: {
  reportId: string;
  onOpen: (reportId: string) => void;
}) => {
  const { t } = useTranslation("settings");

  return (
    <ManuscriptProcessingRow
      label={t("organisation.manuscriptProcessing.entryId.label")}
      align="start"
    >
      <button
        type="button"
        onClick={() => onOpen(reportId)}
        title={t("organisation.manuscriptProcessing.entryId.open")}
        className="group min-w-0 grow text-left"
      >
        <Text
          as="span"
          variant="link"
          numeric="mono"
          className="break-all underline-offset-2 group-hover:underline"
        >
          {reportId}
        </Text>
      </button>
      <ManuscriptProcessingCopyButton
        value={reportId}
        label={t("organisation.manuscriptProcessing.entryId.copy")}
        copiedMessage={t("organisation.manuscriptProcessing.entryId.copied")}
      />
    </ManuscriptProcessingRow>
  );
};
